import * as Yup from 'yup';

export const BaseInterestedConstraints = {
	fname: Yup.string().required(),
	lname: Yup.string().required(),
	email: Yup.string().email().required(),
	telephone: Yup.string()
		.matches(/[\+?\-?0-9]{7,}/)
		.required(),
};
export const InvestorsSchema = values =>
	Yup.object().shape({
		names: Yup.string().required(),
		email: Yup.string().email().required(),
		telephone: Yup.string()
			.matches(/[\+?\-?0-9]{7,}/)
			.required(),
		message: Yup.string().required(),
		terms: Yup.bool().oneOf([true]).required(),
	});

export const BaseValidatonSchema = values =>
	Yup.object().shape({
		...BaseInterestedConstraints,
		terms: Yup.bool().oneOf([true]).required(),
		rooms_amount: Yup.string().required(),
	});

const typeDocuments = Yup.string()
	.when('idType', {
		is: 'RUC',
		then: () =>
			Yup.string()
				.matches(/^\d{11}$/, 'RUC debe tener 10 dígitos')
				.required(),
	})
	.when('idType', {
		is: 'Pasaporte',
		then: () =>
			Yup.string()
				.matches(/^[a-zA-Z0-9]{14}$/, 'Carnet de extranjeria debe ser alfanumérico y tener 9 caracteres')
				.required(),
	})
	.when('idType', {
		is: 'DNI',
		then: () =>
			Yup.string()
				.matches(/^\d{8}$/, 'DNI debe tener 8 dígitos')
				.required(),
	})
	.when('idType', {
		is: 'CE',
		then: () =>
			Yup.string()
				.matches(/^\d{9}$/, 'Carnet de extranjeria debe tener 9 dígitos')
				.required(),
	})
	.required();

export const bookSchema = values =>
	Yup.object().shape({
		...BaseInterestedConstraints,
		project: Yup.string().required(),
		mlname: Yup.string().required(),
		idType: Yup.string().required(),
		idNumber: typeDocuments,
		region: Yup.string().required(),
		province: Yup.string().required(),
		district: Yup.string().required(),
		address: Yup.string().required(),
		typeOfGood: Yup.string().required(),
		orderNumber: Yup.number().required(),
		amount: Yup.number().required(),
		goodDescription: Yup.string().required(),
		complaintType: Yup.string().required(),
		complaintDetail: Yup.string().required(),
		consumerPetition: Yup.string().required(),
		sellerAction: Yup.string().required(),
		// terms: Yup.bool().oneOf([true]).required(),
	});

export const ContactUsValidationSchema = values =>
	Yup.object().shape({
		...BaseInterestedConstraints,
		rooms_amount: Yup.string().required(),
		project: Yup.string().required(),
		terms: Yup.bool().oneOf([true]).required(),
	});
export const contactCenterSchema = values =>
	Yup.object().shape({
		names: Yup.string().required(),
		email: Yup.string().email().required(),
		telephone: Yup.string()
			.matches(/[\+?\-?0-9]{7,}/)
			.required(),
		project: Yup.string().required(),
		apartament: Yup.string().required(),
		file: Yup.string().required(),
		message: Yup.string().required(),
		terms: Yup.bool().oneOf([true]).required(),
	});

export const LandSellerValidationSchema = values =>
	Yup.object().shape({
		names: Yup.string().required(),
		email: Yup.string().email().required(),
		telephone: Yup.string()
			.matches(/[\+?\-?0-9]{7,}/)
			.required(),
		region: Yup.string().required(),
		district: Yup.string().required(),
		address: Yup.string().required(),
		file: Yup.string().required(),
		message: Yup.string().required(),
		terms: Yup.bool().oneOf([true]).required(),
	});
